import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles.module.css"; // Adjust path/name as needed

const TakeAssessmentPage = () => {
  const navigate = useNavigate();

  const handleStartAssessment = () => {
    navigate("/user-landingpage/Assessment");
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Ready to Take Your Assessment?</h2>
      <p className={styles.description}>
        Before starting, please make sure you have enough time and a stable
        internet connection. When you’re prepared, click the button below to
        begin your assessment.
      </p>
      <button className={styles.startButton} onClick={handleStartAssessment}>
        Start Assessment
      </button>
    </div>
  );
};

export default TakeAssessmentPage;
